import { createFileRoute } from "@tanstack/react-router";
import LoadingPage from "lib/components/layout/LoadingPage";
import { useFeatures, useProducts } from "lib/security/client";
import { useUserContext } from "lib/state/UserContextProvider";

/**
 * Public post-CTA confirmation page for a saved `HomePlan`. Shows the
 * selected options summary, pricing breakdown, and brochure download — the
 * landing page a buyer sees after submitting their plan.
 */
function ShowroomPlanOverview() {
  const { builder, builderLoading } = useUserContext();
  useFeatures(!!builderLoading, ["showroomUnification"]);
  useProducts(builder, !!builderLoading, ["showroom"]);
  return <LoadingPage pageTitle="Showroom" />;
}

export const Route = createFileRoute("/showroom/plan/$home_plan_id/overview")({
  component: ShowroomPlanOverview,
  staticData: { isPublicPage: true },
});
